export default "/assets/images/chart-sm-01.386def8e225e1f38.svg";